/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SystemStatusResponseModel } from '../../models/system-status-response-model';

export interface ScanSystemStatusGet$Params {
}

export function scanSystemStatusGet(http: HttpClient, rootUrl: string, params?: ScanSystemStatusGet$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<Array<SystemStatusResponseModel>>> {
  const rb = new RequestBuilder(rootUrl, scanSystemStatusGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<Array<SystemStatusResponseModel>>;
    })
  );
}

scanSystemStatusGet.PATH = '/Scan/SystemStatus';
